<template>
    <section class="news-list">
        <div class="layout-banner">
            <div class="banner">
                <div class="banner-text w-1200">
                    <div class="big-text">新 / 闻 / 资 / 讯</div>
                    <!-- <div class="sm-text">须臾此间，精彩呈现</div> -->
                    <div class="e-text">NEWS INFORMATION</div>
                </div>
            </div>
            <Nav :activeIndex='""'></Nav>
        </div>
        <div class="news-list-content w-1200">
            <ul>
                <li v-for="(item,i) in articleList" :key="i" @click="$router.push({path:'/Article',query:{id:i}})">
                    <img :src="item.imgSrc" alt="">
                    <div class="newslist">
                        <h2>{{item.title}}</h2>
                        <p class="c-article-text" v-html="item.content"></p>
                        <p class="c-article-time">{{item.time}}</p>
                    </div>
                </li>
            </ul>
            <el-pagination
            class="ta-c"
            background
            layout="prev, pager, next"
            :total="articleList.length">
            </el-pagination>
        </div>
        <Footer></Footer>
        <Cornerbar></Cornerbar>
    </section>
</template>

<script>
import Nav from '@/components/Nav'
import Footer from '@/components/Footer'
import Cornerbar from '@/components/Cornerbar'
import articleJson from '@/http/data/news.json'
export default {
  components: {
    Nav,
    Footer,
    Cornerbar
  },
  data () {
    return {
      articleList: []
    }
  },
  methods: {},
  created () {
    this.articleList = JSON.parse(JSON.stringify(articleJson.data))
    this.articleList.forEach(item => {
      item.content = item.content.substr(0, 180) + '...'
    })
  }
}
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
@import "~@/styles/variable.scss";
.news-list{
    .layout-banner{
        position: relative;
        height: 350px;
    }
    .banner{
        background: url(../../assets/banner7.png) 100% no-repeat;
        // transition: all 7.6s cubic-bezier(0.04, 0.79, 1, 1) !important;
        // transform: scale(1.02);
        position: absolute;
        top: 0;
        width: 100%;
        height: 350px;
        overflow: hidden;
        background-repeat: no-repeat;
        background-position: center center;
        background-color: #0b0f1a;
        .banner-text{
            font-family: 'SourceHanSansCN-Regular';
            margin: 0 auto;
            padding-top: 150px;
            animation-duration: 2.5s;
            text-align: center;
            .big-text{
                color: #fff;
                height: 67px;
                font-size: 30px;
                line-height: 67px;
                letter-spacing: 1px;
            }
            .sm-text{
                line-height: 30px;
                font-size: 16px;
                letter-spacing: 1px;
                color: #fff;
            }
            .e-text{
                font-size: 42px;
                letter-spacing: 1px;
                color: #fff;
                font-family: Arial, Helvetica, sans-serif;
                opacity: 0.4;
            }
        }
    }
    .news-list-content{
        padding: 60px 0;
        ul{
            li{
                height: 190px;
                margin-bottom: 50px;
                cursor: pointer;
                overflow: hidden;
                padding: 20px;
                transition: box-shadow .3s, border .3s, background-color .3s, color .3s, transform .3s;
                &:hover{
                    transform: translateY(-3px);
                    box-shadow: 0px 3px 12px rgba(102, 102, 102, 0.16);
                    transition: box-shadow .3s, border .3s, background-color .3s, color .3s, transform .3s;
                }
                img{
                    height: 100%;
                    float: left;
                }
                .newslist{
                    height: 100%;
                    margin-left: 240px;
                    padding: 28px 20px 32px 26px;
                    position: relative;
                    h2{
                        position: absolute;
                        padding-left: 26px;
                        top: -2px;
                        left: 0;
                        width: 100%;
                        height: 28px;
                        font-size: 20px;
                        font-weight: 400;
                        color: #333333;
                        line-height: 28px;
                        vertical-align: top;
                    }
                    .c-article-text{
                        padding: 8px 0;
                        font-size: 14px;
                        font-weight: 400;
                        color: #74778b;
                        line-height: 22px;
                        width: 100%;
                        height: 78px;
                        overflow: hidden;
                    }
                    .c-article-time{
                        position: absolute;
                        padding-left: 26px;
                        bottom: -4px;
                        left: 0;
                        width: 100%;
                        height: 32px;
                        line-height: 32px;
                        font-size: 12px;
                        font-weight: 300;
                        color: #74778b;
                        vertical-align: bottom;
                    }
                }
            }
        }
    }
}
</style>
